import { Drawer, Grid } from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { useNavigate, useParams } from "react-router-dom";
import { FileUploadTypeAutoComplete } from "../../_components/autocomplete/fileUploadType.autoComplete";
import { PrimaryButton } from "../../_components/button/primary.button";
import { DrawerHeader } from "../../_components/drawer/header.drawer";
import { toastr } from "../../_components/toastr/toastr";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { fileUploadService } from "../../_services/fileUpload.service";
import { useDrawerStyles } from "../../_styles/drawer.styles";

export const UserProfileUploadManageDrawer = (params: { emitOnSave(): void, emitOnClose(): void }) => {

    const navigate = useNavigate();
    const { fileId, userId } = useParams<{ fileId: string, userId: string }>();
    const [isSaving, setIsSaving] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const resetData = () => ({
        id: fileId,
        fileUploadTypeId: ""
    });

    const [data, setData] = useState<any>(resetData);

    useEffect(() => {
        console.log(fileId);
        if (fileId != null)
            fetchData();
        else
            setData(resetData);
    }, [fileId]);

    function fetchData() {
        if (!fileId) return;

        setIsLoading(true)
        return fileUploadService
            .get(Number(fileId))
            .then(
                (json) => {
                    setData({ ...json, expiryDate: moment(json.expiryDate).format('YYYY-MM-DD'), issueDate: moment(json.issueDate).format('YYYY-MM-DD') });
                }, handleErrorResponse
            )
            .finally(() => {
                setIsLoading(false);
            });
    }

    function submit(e: any) {
        e.preventDefault();
        setIsSaving(true);
        var formData = new FormData();
        formData.append(`userId`, userId?.toString() || "");
        var fileInputField = document.getElementById("file")
        formData.append("file", (fileInputField as any)?.files[0]);
        formData.append("fileUploadTypeId", data.fileUploadTypeId);

        fileUploadService.post(formData)
            .then(
                () => { toastr.success("Image updated"); params.emitOnSave() },
                (e) => { toastr.error("Invalid image"); }
            ).finally(() => {
                setIsSaving(false);
            })
    }

    function disable() {
        setIsLoading(true);
        return fileUploadService
            .disable(Number(fileId))
            .then(
                (d: any) => {
                    toastr.success("Disabled successfully");
                    params.emitOnSave();
                }, handleErrorResponse
            )
            .finally(() => setIsLoading(false));
    }

    function handleChange(event: any) {
        setData((_data: any) => ({ ..._data, [event.target.name]: event.target.value }))
    };

    return (

        <Drawer
            anchor={"right"}
            variant="persistent"
            open={true}
            ModalProps={{
                keepMounted: true
            }}
        >

            <div
                tabIndex={0}
                role="button">

                <div>

                    <DrawerHeader name={(!!fileId) ? "Update File" : "Create File"} onClose={params.emitOnClose} />

                    <ValidatorForm
                        onSubmit={submit}
                        noValidate>

                        <Grid container spacing={1} sx={useDrawerStyles.container}>

                            <Grid item xs={12}>
                                <FileUploadTypeAutoComplete
                                    isRequired
                                    itemId={data.fileUploadTypeId}
                                    name={"fileUploadTypeId"}
                                    disabled={data.id}
                                    onItemChange={handleChange} />
                            </Grid>


                            <Grid item xs={12}>
                                <TextValidator
                                    label="Document Upload"
                                    value={data._uploadUrl}
                                    disabled={data.id}
                                    name="_uploadUrl"
                                    type="file"
                                    id="file"
                                    fullWidth
                                    required
                                    validators={['required']}
                                    errorMessages={['This field is required']}
                                    onChange={handleChange}
                                    variant="filled"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>

                        </Grid>

                        <Grid container spacing={1} sx={useDrawerStyles.container}>

                            <Grid item xs={(data.id === 0 ? 12 : 6)}>
                                <PrimaryButton
                                    isSaving={isSaving}
                                    isLoading={isLoading}
                                    disabled={data.id}
                                    type="submit"
                                    variant="save">{"Save"}
                                </PrimaryButton>
                            </Grid>

                            {data.id > 0 &&
                                <Grid item xs={6}>
                                    <PrimaryButton
                                        type="button"
                                        variant="danger"
                                        disabled={isLoading}
                                        onClick={disable}
                                        icon="block"
                                    >
                                        Disable
                                    </PrimaryButton>
                                </Grid>
                            }

                        </Grid>

                    </ValidatorForm>
                </div>
            </div>
        </Drawer >
    );
};